var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style.eLabel] = true, _obj[_vm.$style.labelMargin] = _vm.size === 'md', _obj[_vm.$style.formFieldLabel] = _vm.size === 'sm', _obj[_vm.$style.redesignedLabel] = _vm.newStyle, _obj )},[_vm._v("\n  "+_vm._s(_vm.label)+"\n  "),(_vm.markRequired)?_c('span',{staticClass:"text-danger"},[_vm._v("*")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }